<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <edit-area-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></edit-area-form>
  </j-modal>
</template>

<script>

  import EditAreaForm from "./EditAreaForm";
  export default {
    name: 'EditAreaModal',
    components: {
      EditAreaForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(record);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(data){
        this.$emit('ok',data);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>